module.exports = __webpack_public_path__ + "img/trailerRearRightOutline.a387413f.svg";